import { render, staticRenderFns } from "./LCDPolarizationViz.vue?vue&type=template&id=1125887a&scoped=true"
import script from "./LCDPolarizationViz.vue?vue&type=script&lang=js"
export * from "./LCDPolarizationViz.vue?vue&type=script&lang=js"
import style0 from "./LCDPolarizationViz.vue?vue&type=style&index=0&id=1125887a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125887a",
  null
  
)

export default component.exports